webpackJsonp([0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(298);


/***/ },

/***/ 298:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(301);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularMaterial = __webpack_require__(371);
	
	var _angularMaterial2 = _interopRequireDefault(_angularMaterial);
	
	var _common = __webpack_require__(377);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _components = __webpack_require__(451);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _app = __webpack_require__(478);
	
	var _app2 = _interopRequireDefault(_app);
	
	__webpack_require__(482);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('app', [_angularUiRouter2.default, _angularMaterial2.default, _common2.default, _components2.default]).config(["$locationProvider", function ($locationProvider) {
	  "ngInject";
	  // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
	  // #how-to-configure-your-server-to-work-with-html5mode
	
	  $locationProvider.html5Mode(true).hashPrefix('!');
	}]).component('app', _app2.default);

/***/ },

/***/ 377:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _navbar = __webpack_require__(378);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _resources = __webpack_require__(387);
	
	var _resources2 = _interopRequireDefault(_resources);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commonModule = _angular2.default.module('app.common', [_navbar2.default, _resources2.default]).name;
	
	exports.default = commonModule;

/***/ },

/***/ 378:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(301);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _navbar = __webpack_require__(379);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var navbarModule = _angular2.default.module('navbar', [_angularUiRouter2.default]).component('navbar', _navbar2.default).name;
	
	exports.default = navbarModule;

/***/ },

/***/ 379:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _navbar = __webpack_require__(380);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _navbar3 = __webpack_require__(381);
	
	var _navbar4 = _interopRequireDefault(_navbar3);
	
	__webpack_require__(383);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var navbarComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _navbar2.default,
	  controller: _navbar4.default
	};
	
	exports.default = navbarComponent;

/***/ },

/***/ 380:
/***/ function(module, exports) {

	module.exports = "<div>\n    <md-toolbar>\n          <div class=\"md-toolbar-tools\">\n            <p>Resources Sample App</p>\n            <span flex></span>\n          </div>\n    </md-toolbar>\n</div>\n"

/***/ },

/***/ 381:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(382);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavbarController = function NavbarController() {
	  (0, _classCallCheck3.default)(this, NavbarController);
	};
	
	exports.default = NavbarController;

/***/ },

/***/ 383:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(384);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(386)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./navbar.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./navbar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 384:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(385)();
	// imports
	exports.push([module.id, "@import url(http://fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%}.navbar{height:6.5rem;background-color:#0277bd;padding:1rem}.navbar .logo,.navbar .nav-links{display:inline-block}.navbar .logo{color:#f5f5f5;margin-right:50%}.navbar .nav-links span{color:#f5f5f5;font-size:1.6rem}", ""]);
	
	// exports


/***/ },

/***/ 387:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _resources = __webpack_require__(388);
	
	var _resources2 = _interopRequireDefault(_resources);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userModule = _angular2.default.module('resources', []).factory('Resources', _resources2.default).name;
	
	exports.default = userModule;

/***/ },

/***/ 388:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ResourceFactory;
	
	var _keygen = __webpack_require__(389);
	
	var _keygen2 = _interopRequireDefault(_keygen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ResourceFactory() {
	    var resources = [{
	        name: 'Google',
	        url: 'http://google.com',
	        description: 'Search Engine Site',
	        type: 'website',
	        shareable: true,
	        id: 64846489464
	    }];
	    var types = ['website', 'podcast', 'book'];
	    var createEmptyResource = function createEmptyResource(type) {
	        return {
	            url: '',
	            description: '',
	            type: type,
	            shareable: false,
	            id: _keygen2.default.url(_keygen2.default.small)
	        };
	    };
	    var addResource = function addResource(resource) {
	        resources.push(resource);
	    };
	    var removeResource = function removeResource(index) {
	        resources.splice(index, 1);
	    };
	    var editResource = function editResource(index, resource) {
	        resources[index] = resource;
	    };
	    return {
	        resources: resources,
	        addResource: addResource,
	        createEmptyResource: createEmptyResource,
	        types: types,
	        editResource: editResource,
	        removeResource: removeResource
	    };
	};

/***/ },

/***/ 396:
/***/ function(module, exports) {

	/* (ignored) */

/***/ },

/***/ 427:
/***/ function(module, exports) {

	/* (ignored) */

/***/ },

/***/ 451:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _home = __webpack_require__(452);
	
	var _home2 = _interopRequireDefault(_home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var componentModule = _angular2.default.module('app.components', [_home2.default]).name;
	
	exports.default = componentModule;

/***/ },

/***/ 452:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(301);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _home = __webpack_require__(453);
	
	var _home2 = _interopRequireDefault(_home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var homeModule = _angular2.default.module('home', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/');
	
	  $stateProvider.state('home', {
	    url: '/',
	    component: 'home'
	  });
	}]).component('home', _home2.default).name;
	
	exports.default = homeModule;

/***/ },

/***/ 453:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _home = __webpack_require__(454);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _home3 = __webpack_require__(455);
	
	var _home4 = _interopRequireDefault(_home3);
	
	__webpack_require__(476);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var homeComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _home2.default,
	  controller: _home4.default
	};
	
	exports.default = homeComponent;

/***/ },

/***/ 454:
/***/ function(module, exports) {

	module.exports = "<navbar></navbar>\n<section layout-gt-sm=\"row\" layout=\"column\" class=\"home\">\n    <md-content flex>\n      <md-list flex=\"\">\n        <md-list-item\n            class=\"md-3-line\"\n            ng-repeat=\"item in $ctrl.resources\"\n            ng-mouseenter=\"$ctrl.handleHover($index);\"\n            ng-mouseleave=\"$ctrl.handleHover();\"\n        >\n          <img class=\"md-avatar\" src=\"{{$ctrl.images[item.type]}}\" />\n          <div class=\"md-list-item-text\" layout=\"column\">\n            <h3>{{ item.name }}</h3><span>{{ item.url }}</span>\n            <h4>{{ item.description }}</h4>\n          </div>\n          <div\n              class=\"md-secondary-container\"\n              ng-if=\"$ctrl.activeResource === $index\"\n          >\n              <i class=\"material-icons edit-resource\" ng-click=\"$ctrl._editResource($index)\">create</i>\n              <i class=\"material-icons clear-resource\" ng-click=\"$ctrl._removeResource($index)\">clear</i>\n          </div>\n          <md-divider ng-if=\"!$last\"></md-divider>\n        </md-list-item>\n      </md-list>\n      <md-subheader\n          class=\"md-no-sticky\"\n          layout=\"row\"\n          layout-align=\"end center\"\n      >\n          <md-button\n              class=\"md-raised md-primary add-resource-btn\"\n              ng-click=\"$ctrl._editResource();\"\n              ng-if=\"$ctrl.showAddResource\"\n          >\n              Add Resource\n          </md-button>\n          <section\n              ng-if=\"$ctrl.editNew || $ctrl.editCurrent\"\n          >\n              <md-button\n                  class=\"md-raised md-info\"\n                  ng-click=\"$ctrl.clearResource();\"\n              >\n                Cancel\n              </md-button>\n              <md-button\n                  class=\"md-raised md-primary\"\n                  ng-click=\"$ctrl.saveResource($ctrl.editCurrent, $index);\"\n              >\n                  Save Resource\n              </md-button>\n          </section>\n      </md-subheader>\n      <md-content ng-if=\"$ctrl.editNew || $ctrl.editCurrent\" layout-padding>\n          <form>\n              <div layout-gt-sm=\"row\">\n                  <md-input-container class=\"md-block\" flex-gt-sm=\"25\" flex=\"50\" ng-class=\"{'md-input-invalid': $ctrl.submitted && !$ctrl.emptyResource.type}\">\n                   <label>Type</label>\n                   <md-select ng-model=\"$ctrl.emptyResource.type\" required>\n                     <md-option ng-repeat=\"type in $ctrl.types\" value=\"{{type}}\">\n                       {{type.toUpperCase()}}\n                     </md-option>\n                   </md-select>\n                 </md-input-container>\n              </div>\n              <div layout-gt-sm=\"row\">\n                <md-input-container\n                    class=\"md-block\"\n                    flex-gt-sm=\"50\"\n                    flex=\"100\"\n                    ng-class=\"{'md-input-invalid': $ctrl.submitted && !$ctrl.emptyResource.name}\"\n                >\n                  <label>Name</label>\n                  <input ng-model=\"$ctrl.emptyResource.name\" required >\n                </md-input-container>\n                <md-input-container class=\"md-block\" flex-gt-sm=\"50\" flex=\"100\" ng-class=\"{'md-input-invalid': $ctrl.submitted && !$ctrl.emptyResource.url}\">\n                  <label>Link</label>\n                  <input ng-model=\"$ctrl.emptyResource.url\" required type=\"url\">\n                </md-input-container>\n              </div>\n              <div>\n                  <md-input-container class=\"md-block\" flex-gt-sm=\"50\" flex=\"100\">\n                      <label>Description</label>\n                      <textarea\n                          ng-model=\"$ctrl.emptyResource.description\"\n                          md-maxlength=\"150\"\n                          rows=\"1\"\n                      >\n                      </textarea>\n                  </md-input-container>\n              </div>\n\n          </form>\n      </md-content>\n    </md-content>\n</section>\n"

/***/ },

/***/ 455:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(382);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(456);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _dataImages = __webpack_require__(475);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeController = function () {
	    HomeController.$inject = ["Resources"];
	    function HomeController(Resources) {
	        "ngInject";
	
	        (0, _classCallCheck3.default)(this, HomeController);
	        this.resources = Resources.resources;
	        this.createEmptyResource = Resources.createEmptyResource;
	        this.addResource = Resources.addResource;
	        this.editResource = Resources.editResource;
	        this.removeResource = Resources.removeResource;
	        this.types = Resources.types;
	        this.editNew = false;
	        this.editCurrent = false;
	        this.showAddResource = true;
	        this.emptyResource = this.createEmptyResource();
	        this.submitted = false;
	        this.activeResource = null;
	        this.images = { website: _dataImages.website, podcast: _dataImages.podcast, book: _dataImages.book };
	    }
	
	    (0, _createClass3.default)(HomeController, [{
	        key: "saveResource",
	        value: function saveResource(isEdit, index) {
	            var _emptyResource = this.emptyResource,
	                name = _emptyResource.name,
	                url = _emptyResource.url,
	                type = _emptyResource.type;
	
	            this.submitted = true;
	            if (!name || !url || !type) {
	                return;
	            }
	            if (isEdit) {
	                this.editResource(index, this.emptyResource);
	            } else {
	                this.addResource(this.emptyResource);
	            }
	            this.clearResource();
	        }
	    }, {
	        key: "clearResource",
	        value: function clearResource() {
	            this.emptyResource = this.createEmptyResource();
	            this.editNew = false;
	            this.editCurrent = false;
	            this.submitted = false;
	            this.showAddResource = true;
	        }
	    }, {
	        key: "handleHover",
	        value: function handleHover(index) {
	            if (index !== undefined) {
	                this.activeResource = index;
	                return;
	            }
	            this.activeResource = null;
	        }
	    }, {
	        key: "_editResource",
	        value: function _editResource(index) {
	            if (index !== undefined) {
	                this.emptyResource = this.resources[index];
	                this.editCurrent = true;
	            }
	            this.editNew = true;
	            this.showAddResource = false;
	        }
	    }, {
	        key: "_removeResource",
	        value: function _removeResource(index) {
	            this.removeResource(index);
	        }
	    }]);
	    return HomeController;
	}();
	
	exports.default = HomeController;

/***/ },

/***/ 475:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var podcast = exports.podcast = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAABY0lEQVR4Ae3TzUpCQRjG8T8cPFa6TaNWmV1AUStrF4F3EHkDkUiBQdeSRavwDoJWFUERamkt+vISwq2UlKfN8G5izsd4aNP83u3znkdmHP6JOcrU6dBjwIAebepskyMGDiVu8TRzwyYOIyjSxQuYF9YxMsExXsg5ZJyIstzjyQw5p0qBDC4uWVbY45IhkqBFJtrn32T1i5rmOvMc8Y0cFZPhD0d+PU8s4meJV8k2GSMUOXtOSREkzZnkDwihiHyeBGEkkArWCODQlcNJEVZaDuoZB18ludoFoliW697Aj7zaGhHJzV3jIy//+xxRzcu7mEWrrCIXmLhS21to1VWkiol9tX2CVkdFCphYVdt3aPVUJIOJKbX9jtZARVxMJNX2J1qeGlOybwvMCzRjnrcFtsAW/H3BRywFfbRasRQ00NqNpaCCVpLHkQvauPiY4WGkgjbTBEiyQ5N+5II+DSq4/GJZ1g9D4lctbORmZgAAAABJRU5ErkJggg==';
	var book = exports.book = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAkElEQVR4Ae3XMQ6CQBCF4b/kHBRkL7N30hMt4Hn0CIYACeVoYWFhwsiyCZr3/n6/ZLtBO+QCLSP2ZTM9wff8gG1s8BAtllHH6sYsYGJ19urTHMQvAgIECBBQc3lWlwEqziwYxsKJam8gcsPeuhL3BfwJECBAgIB/BObSB0ifBaSyR+CdBjxEx7ThcxINB5z2ACL0XQn3Bb2gAAAAAElFTkSuQmCC';
	var website = exports.website = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAN0lEQVR4Ae3NoQ0AIBAEQfpv+vEYxB0JYnYLmCUVm+6AAEgDAAAAAACQA80BfeDsH2AeD7gDkjZScd0/vNLqOgAAAABJRU5ErkJggg==';

/***/ },

/***/ 476:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(477);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(386)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./home.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./home.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 477:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(385)();
	// imports
	
	
	// module
	exports.push([module.id, ".home .clear-resource,.home .edit-resource{cursor:pointer;margin:0 5px;transition:color .2s}.home .edit-resource:hover{color:blue}.home .clear-resource:hover{color:red}", ""]);
	
	// exports


/***/ },

/***/ 478:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _app = __webpack_require__(479);
	
	var _app2 = _interopRequireDefault(_app);
	
	__webpack_require__(480);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appComponent = {
	  template: _app2.default,
	  restrict: 'E'
	};
	
	exports.default = appComponent;

/***/ },

/***/ 479:
/***/ function(module, exports) {

	module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\n<div class=\"app\">\n  <div ui-view></div>\n</div>\n"

/***/ },

/***/ 480:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(481);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(386)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 481:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(385)();
	// imports
	exports.push([module.id, "@import url(http://fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, ".app,body{height:100%}", ""]);
	
	// exports


/***/ }

});


// WEBPACK FOOTER //
// app.bundle.js